import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import KlkPoptip from '@klook/klook-ui/lib/poptip';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

let ChatEntranceIcon = class ChatEntranceIcon extends Vue {
    get imageRatio() {
        if (this.text) {
            return this.klook.platform === 'desktop'
                ? 'desktopChatEntranceIconWithText'
                : 'mobileChatEntranceIconWithText';
        }
        return this.klook.platform === 'desktop' ? 'desktopChatEntranceIcon' : 'mobileChatEntranceIcon';
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ChatEntranceIcon.prototype, "klook", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ChatEntranceIcon.prototype, "icon", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ChatEntranceIcon.prototype, "text", void 0);
ChatEntranceIcon = __decorate([
    Component
], ChatEntranceIcon);
var script$1 = ChatEntranceIcon;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".chat-entrance-icon-wrapper[data-v-6d00e9e4]{align-items:center;display:flex;flex-direction:column;height:32px;justify-content:center;width:32px}.chat-entrance-icon-wrapper img[data-v-6d00e9e4]{height:24px;width:24px}";
styleInject(css_248z$1);

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$1 = script$1;
/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("section", { staticClass: "chat-entrance-icon-wrapper" }, [
    _c("img", {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.icon,
          expression: "icon",
        },
      ],
      class: { "with-text": _vm.text },
      attrs: { "data-img-type": _vm.imageRatio, alt: "" },
    }),
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = "data-v-6d00e9e4";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

function convertToBackendCode(lang) {
    const f2bLanguageMap = {
        de: 'de_DE',
        en: 'en_BS',
        'en-AU': 'en_AU',
        'en-CA': 'en_CA',
        'en-GB': 'en_GB',
        'en-HK': 'en_HK',
        'en-IN': 'en_IN',
        'en-MY': 'en_MY',
        'en-NZ': 'en_NZ',
        'en-PH': 'en_PH',
        'en-SG': 'en_SG',
        'en-US': 'en_US',
        es: 'es_ES',
        fr: 'fr_FR',
        id: 'id_ID',
        it: 'it_IT',
        ja: 'ja_JP',
        ko: 'ko_KR',
        ru: 'ru_RU',
        th: 'th_TH',
        vi: 'vi_VN',
        'zh-CN': 'zh_CN',
        'zh-HK': 'zh_HK',
        'zh-TW': 'zh_TW',
        'ms-MY': 'ms_MY',
    };
    return f2bLanguageMap[lang];
}
/**
 * 获取webview打开的版本号，返回版本号如"4.2.0",若不是app打开返回false
 */
function getAppVersion(userAgentStr) {
    const userAgent = userAgentStr || navigator.userAgent;
    const reg = /klook\/(\d+\.)+\d+/;
    const matchArr = userAgent.match(reg);
    if (matchArr) {
        const versionStr = matchArr[0];
        const versionArr = versionStr.split('/');
        return versionArr[1];
    }
    return false;
}
const getReferrer = () => {
    let referrer = '';
    try {
        referrer = window.top.document.referrer;
    }
    catch (_a) {
        if (window.parent) {
            try {
                referrer = window.parent.document.referrer;
            }
            catch (_b) {
                referrer = '';
            }
        }
    }
    if (referrer === '') {
        referrer = document.referrer;
    }
    if (typeof referrer === 'undefined') {
        referrer = '';
    }
    return referrer;
};
/**
 * 拼装 UDesk im 链接
 */
const formatUDeskParams = (basicUrl, params) => {
    try {
        const basicUrlControl = new URL(basicUrl);
        for (const [key, value] of Object.entries(Object.assign(Object.assign({}, params), { pre_url: getReferrer() }))) {
            basicUrlControl.searchParams.set(key, value);
        }
        return basicUrlControl.toString();
    }
    catch (_a) {
        return basicUrl;
    }
};

function detectProj(project, newWebLogic, nuxtWebLogic) {
    switch (project) {
        case 'new-web':
            return newWebLogic();
        case 'nuxt':
            return nuxtWebLogic();
    }
}
function getRightPath(project, pathname) {
    return detectProj(project, () => pathname, () => pathname.substring(1));
}
const jumpPath = (project, ctx, url) => {
    return detectProj(project, () => {
        var _a;
        return (_a = ctx.klook) === null || _a === void 0 ? void 0 : _a.getLangPath(url);
    }, () => {
        return ctx.href(url);
    });
};
const httpGET = (url, projectCtx, params = {}, headers = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const innerHeaders = {};
    if (projectCtx.ctx.isFromApp) {
        // 新 Chat 全量前必须带入，后端会根据这个header判定实验（新老 Chat），做最终跳转链接的下发
        innerHeaders['Klook-App-Version'] = getAppVersion();
    }
    return detectProj(projectCtx.project, () => {
        const { klook } = projectCtx.ctx;
        return new Promise((resolve, reject) => {
            try {
                klook === null || klook === void 0 ? void 0 : klook.ajaxGet(url, Object.assign({}, params), function (resp) {
                    resolve(resp);
                }, Object.assign(Object.assign({}, innerHeaders), headers));
            }
            catch (e) {
                console.log('%cError:', 'color: red;', e);
                reject(e);
            }
        });
    }, () => __awaiter(void 0, void 0, void 0, function* () {
        const { axios } = projectCtx.ctx;
        try {
            return yield (axios === null || axios === void 0 ? void 0 : axios.$get(url, {
                params,
                headers: Object.assign(Object.assign({}, innerHeaders), headers),
            }));
        }
        catch (e) {
            console.log('%cError:', 'color: red;', e);
            return null;
        }
    }));
});

let ChatEntrance = class ChatEntrance extends Vue {
    constructor() {
        super(...arguments);
        this.hasSession = false;
        this.badgeNum = 0;
        this.showPopup = false;
        this.chatEntranceConfig = {};
        this.chatLink = '';
    }
    get isDesktop() {
        return this.platform === 'desktop';
    }
    get isCN() {
        return this.market === 'cn';
    }
    get previousPage() {
        // 组件约定强制传入
        return this.previousPageName;
    }
    get shouldDisplay() {
        // 特定逻辑，只有在 Account 页面才走 Session 逻辑，非 Account 页面只通过 Admin 语言开关控制
        return (this.previousPage !== 'Account' || this.badgeNum || (this.badgeNum === 0 && this.hasSession));
    }
    // 业务线（租车）SPA 跳转需要重新拉取配置
    previousPageChange() {
        this.fetchChatEntranceData();
    }
    getUnreadCount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield httpGET('/v1/faqchatcommsrv/conversation/chat_message/unreadcount', {
                    project: this.project,
                    ctx: {
                        klook: this.klook,
                        axios: this.axios,
                        isFromApp: this.isFromApp,
                    },
                });
                const { success, result } = res || {};
                if (success) {
                    const { have_ticket, unread_count } = result;
                    return {
                        hasSession: have_ticket,
                        badgeNum: unread_count,
                    };
                }
                return {};
            }
            catch (e) {
                return {};
            }
        });
    }
    fetchChatEntranceData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.chatEntranceConfig = {};
            // 请求后端配置接口，灌入data
            yield httpGET('/v1/faqchatcommsrv/unifiedentrance/config', {
                project: this.project,
                ctx: {
                    klook: this.klook,
                    axios: this.axios,
                    isFromApp: this.isFromApp,
                },
            }, { page_name: this.previousPage }).then((res) => __awaiter(this, void 0, void 0, function* () {
                if ((res === null || res === void 0 ? void 0 : res.success) && res.result) {
                    clearTimeout(this.timerStart);
                    clearTimeout(this.timerEnd);
                    const { page_list: pageListConfig, default_config: defaultConfig } = res.result;
                    const entranceConfig = pageListConfig.find((item) => {
                        return item.page_name === this.previousPage;
                    });
                    if (entranceConfig) {
                        const { locales } = entranceConfig;
                        const openConfig = locales.find((item) => item.locale === convertToBackendCode(this.lang));
                        if (!openConfig) {
                            this.$emit('chat-entrance-show', false);
                            return;
                        }
                        const { double_check: doubleCheck } = openConfig;
                        if (!doubleCheck) {
                            // 不需要二次确认
                            // 如果有页面级别的style配置，就不使用默认配置
                            const { 
                            // Chat Entrance Icon
                            icon, 
                            // Chat Entrance Icon Text，暂时只有中文，暂不启用多语言
                            // text,
                            // Chat Entrance 跳转链接
                            action_link: jumpLink, 
                            // Chat Entrance Poptip Switch
                            bubble_switch: poptipSwitch, 
                            // Chat Entrance Poptip Text
                            bubble_text: poptipText, 
                            // Chat Entrance Poptip Duration
                            bubble_trigger_duration: poptipDuration, } = !entranceConfig.config ? defaultConfig : entranceConfig.config;
                            this.chatEntranceConfig = {
                                icon,
                                jumpLink,
                                poptipSwitch,
                                poptipText: poptipText ? poptipText[convertToBackendCode(this.lang)] : '',
                                poptipDuration,
                            };
                            this.setEntranceDisplayTimer(+poptipDuration);
                            if (icon) {
                                const { hasSession = false, badgeNum = 0 } = yield this.getUnreadCount();
                                this.hasSession = hasSession;
                                this.badgeNum = badgeNum;
                                // 外部要知道组件是否成功显示了，来做额外逻辑
                                this.$emit('chat-entrance-show', true);
                            }
                            else {
                                this.$emit('chat-entrance-show', false);
                            }
                        }
                        else {
                            // 需要二次确认逻辑待迭代
                            // 关闭活动详情连带的Contact Section
                            this.$emit('chat-entrance-show', false);
                        }
                    }
                }
            }));
        });
    }
    mounted() {
        this.fetchChatEntranceData();
    }
    setEntranceDisplayTimer(timeDuration) {
        this.timerStart = setTimeout(() => {
            this.showPopup = true;
            if (this.isDesktop) {
                // 5s 后消失
                this.timerEnd = setTimeout(() => {
                    this.showPopup = false;
                    clearTimeout(this.timerEnd);
                }, 5 * 1000);
            }
            clearTimeout(this.timerStart);
        }, timeDuration * 1000);
    }
    routeToChatAction() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            // 只在 mweb 使用弹出登陆
            if ((_a = this.loginOptions) === null || _a === void 0 ? void 0 : _a.isLoggedIn) {
                this.toChat();
                return;
            }
            if (!((_b = this.loginOptions) === null || _b === void 0 ? void 0 : _b.onLogin)) {
                this.toChat();
                return;
            }
            (_d = (_c = this.loginOptions) === null || _c === void 0 ? void 0 : _c.onLogin) === null || _d === void 0 ? void 0 : _d.call(_c, () => __awaiter(this, void 0, void 0, function* () {
                this.toChat();
            }));
        });
    }
    getChatLink() {
        var _a;
        // 同时由于有AB存在，我们在Node层redirect不同版本，因此要带参数处理AB逻辑
        // 目前AB只跑在Activity页面，如果AB全量，只保留一个版本，这个from链接参数可以去除
        const jumpURLObj = new URL(this.chatEntranceConfig.jumpLink);
        const from = jumpURLObj.searchParams.get('from');
        const contextParams = JSON.stringify({
            previousPageName: this.previousPage,
            // previousPageLink: window.location.href, 暂时用不到此参数
            objectId: this.objectId,
            extraInfo: this.extraInfo,
        });
        if (!from) {
            jumpURLObj.searchParams.set('from', this.previousPage);
        }
        jumpURLObj.pathname = getRightPath(this.project, jumpURLObj.pathname);
        jumpURLObj.searchParams.set('context', contextParams);
        // from参数会在进入chat页面前置条件中，作为AB实验的跳转逻辑判断依据，因此需要链接待上当前跳转页信息
        const jumpLink = jumpPath(this.project, {
            klook: this.klook,
            href: (_a = this.href) === null || _a === void 0 ? void 0 : _a.bind(this),
        }, `${jumpURLObj.pathname}${jumpURLObj.search}`);
        return jumpLink;
    }
    /**
     * @deprecated 不应该直接跳转到 udesk
     */
    getUDeskChatLink() {
        return __awaiter(this, void 0, void 0, function* () {
            const isBooking = this.objectId && this.previousPage === 'BookingDetail';
            const order_no = isBooking && this.objectId;
            const contextParams = {
                cur_url: this.previousPage,
                cur_title: document.title,
            };
            const response = yield httpGET(`/v1/usrcsrv/udesk/booking/info/by_order_no${order_no ? `?order_no=${order_no}` : ''}`, {
                project: this.project,
                ctx: {
                    klook: this.klook,
                    axios: this.axios,
                    isFromApp: this.isFromApp,
                },
            });
            const { result, success, error } = response || {};
            if (success && (result === null || result === void 0 ? void 0 : result.link)) {
                return formatUDeskParams(result.link, contextParams);
            }
            console.error('[Load chat link error]', error);
            return 'https://klook.s4.udesk.cn/im_client?web_plugin_id=70295';
        });
    }
    toChat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.chatLink) {
                this.chatLink = this.getChatLink();
                // this.chatLink = this.isCN ? await this.getUDeskChatLink() : this.getSmoochChatLink()
            }
            if (this.isDesktop) {
                window.open(this.chatLink);
            }
            else {
                window.location.href = this.chatLink;
            }
        });
    }
};
__decorate([
    Prop({ type: String, default: 'nuxt' })
], ChatEntrance.prototype, "project", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ChatEntrance.prototype, "klook", void 0);
__decorate([
    Prop({ type: String })
], ChatEntrance.prototype, "lang", void 0);
__decorate([
    Prop({ type: String })
], ChatEntrance.prototype, "platform", void 0);
__decorate([
    Prop({ type: Function })
], ChatEntrance.prototype, "axios", void 0);
__decorate([
    Prop({ type: Function })
], ChatEntrance.prototype, "href", void 0);
__decorate([
    Prop({ type: [String, Number] })
], ChatEntrance.prototype, "objectId", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ChatEntrance.prototype, "extraInfo", void 0);
__decorate([
    Prop({ type: String, default: () => 'AskBtn' })
], ChatEntrance.prototype, "spmName", void 0);
__decorate([
    Prop({ type: String })
], ChatEntrance.prototype, "previousPageName", void 0);
__decorate([
    Prop({ type: Number })
], ChatEntrance.prototype, "bottom", void 0);
__decorate([
    Prop({ type: Boolean })
], ChatEntrance.prototype, "isFromApp", void 0);
__decorate([
    Prop({ type: String, default: 'global' })
], ChatEntrance.prototype, "market", void 0);
__decorate([
    Prop({ type: Object })
], ChatEntrance.prototype, "loginSdkOptions", void 0);
__decorate([
    Prop({
        type: Object,
        default: () => ({
            isLoggedIn: true,
        }),
    })
], ChatEntrance.prototype, "loginOptions", void 0);
__decorate([
    Watch('previousPageName')
], ChatEntrance.prototype, "previousPageChange", null);
ChatEntrance = __decorate([
    Component({
        components: {
            ChatEntranceIcon: __vue_component__$1,
            KlkPoptip,
        },
    })
], ChatEntrance);
var script = ChatEntrance;

var css_248z = ".chat-entrance-wrapper[data-v-63678164]{align-items:center;border-radius:50%;bottom:calc(env(safe-area-inset-bottom) + 108px);box-sizing:border-box;color:#fff;display:flex;flex-direction:column;font-size:12px;font-style:normal;height:48px;justify-content:center;position:fixed;right:18px;transform:translateY(0);transition:all .2s ease-in-out .1s;width:48px;z-index:500}.chat-entrance-wrapper[inline][data-v-63678164]{display:inline;position:static}.chat-entrance-wrapper.desktop[data-v-63678164]{bottom:140px;height:50px;right:40px;width:50px}.chat-entrance-wrapper.mobile[data-v-63678164]{z-index:28}.chat-entrance-wrapper.mobile[data-v-63678164] .klk-poptip-popper:after{right:17px!important}.chat-entrance-wrapper.mobile[data-v-63678164] .klk-poptip-popper-inner{margin:12px 0;max-width:calc(100vw - 32px)!important;padding:0 36px 0 12px;width:max-content}.chat-entrance-wrapper.mobile[data-v-63678164] .klk-poptip-popper-close-btn{top:14px}.chat-entrance-wrapper .chat-entrance[data-v-63678164]{align-items:center;background:linear-gradient(135deg,#ffa673,#f74600);border:0;border-radius:50%;box-shadow:0 4px 10px 0 rgba(0,0,0,.14);display:flex;flex-direction:column;height:48px;justify-content:center;position:relative;width:48px}.chat-entrance-wrapper .chat-entrance .klk-poptip-popper-content[data-v-63678164]{white-space:nowrap}.chat-entrance-wrapper .chat-entrance[data-v-63678164]:hover{box-shadow:0 6px 12px 0 rgba(0,0,0,.12),0 -1px 2px 0 rgba(0,0,0,.08)}.chat-entrance-wrapper .chat-entrance .badge[data-v-63678164]{align-items:center;background:#ff5b00;border:1px solid #fff;border-radius:16px;color:#fff;display:flex;font-size:12px;font-weight:500;height:18px;justify-content:center;left:26px;padding:5px;position:absolute;top:-2px}";
styleInject(css_248z);

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.chatEntranceConfig.icon && _vm.shouldDisplay
    ? _c(
        "section",
        _vm._b(
          {
            class: [
              { "chat-entrance-wrapper": !_vm.$slots.default },
              _vm.platform,
            ],
            style: _vm.bottom ? { bottom: _vm.bottom + "px" } : "",
            on: { click: _vm.routeToChatAction },
          },
          "section",
          _vm.spmName
            ? ((_obj = {}), (_obj["data-spm-module"] = _vm.spmName), _obj)
            : {},
          false
        ),
        [
          _vm._t("default", [
            _vm.platform === "desktop"
              ? [
                  _vm.chatEntranceConfig && _vm.chatEntranceConfig.poptipSwitch
                    ? _c(
                        "klk-poptip",
                        {
                          attrs: {
                            content: _vm.chatEntranceConfig.poptipText,
                            placement: "left",
                            "append-to-body": true,
                          },
                          model: {
                            value: _vm.showPopup,
                            callback: function ($$v) {
                              _vm.showPopup = $$v;
                            },
                            expression: "showPopup",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { "data-spm-item": "__default?typ=entry" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "chat-entrance",
                                  attrs: { href: "javascript:void(0)" },
                                },
                                [
                                  _c("chat-entrance-icon", {
                                    attrs: {
                                      icon: _vm.chatEntranceConfig.icon,
                                      text: _vm.chatEntranceConfig.text,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.badgeNum
                                    ? _c("div", { staticClass: "badge" }, [
                                        _vm.badgeNum > 99
                                          ? _c(
                                              "span",
                                              { staticClass: "plus-mark-box" },
                                              [_c("span", [_vm._v("99+")])]
                                            )
                                          : _c("span", [
                                              _vm._v(_vm._s(_vm.badgeNum)),
                                            ]),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { attrs: { "data-spm-item": "__default?typ=entry" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "chat-entrance",
                              attrs: { href: "javascript:void(0)" },
                            },
                            [
                              _c("chat-entrance-icon", {
                                attrs: {
                                  icon: _vm.chatEntranceConfig.icon,
                                  text: _vm.chatEntranceConfig.text,
                                  "badge-num": _vm.badgeNum,
                                },
                              }),
                              _vm._v(" "),
                              _vm.badgeNum
                                ? _c("div", { staticClass: "badge" }, [
                                    _vm.badgeNum > 99
                                      ? _c(
                                          "span",
                                          { staticClass: "plus-mark-box" },
                                          [_c("span", [_vm._v("99+")])]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(_vm.badgeNum)),
                                        ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                ]
              : _vm.platform === "mobile"
              ? [
                  _vm.chatEntranceConfig && _vm.chatEntranceConfig.poptipSwitch
                    ? _c(
                        "klk-poptip",
                        {
                          attrs: {
                            trigger: "none",
                            placement: "top-end",
                            dark: "",
                            closable: "",
                          },
                          model: {
                            value: _vm.showPopup,
                            callback: function ($$v) {
                              _vm.showPopup = $$v;
                            },
                            expression: "showPopup",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "chat-entrance",
                              attrs: { "data-spm-item": "__default?typ=entry" },
                            },
                            [
                              _c("chat-entrance-icon", {
                                attrs: {
                                  icon: _vm.chatEntranceConfig.icon,
                                  text: _vm.chatEntranceConfig.text,
                                  "badge-num": _vm.badgeNum,
                                },
                              }),
                              _vm._v(" "),
                              _vm.badgeNum
                                ? _c("div", { staticClass: "badge" }, [
                                    _vm.badgeNum > 99
                                      ? _c(
                                          "span",
                                          { staticClass: "plus-mark-box" },
                                          [_c("span", [_vm._v("99+")])]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(_vm.badgeNum)),
                                        ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              attrs: { slot: "content" },
                              on: { click: _vm.routeToChatAction },
                              slot: "content",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.chatEntranceConfig.poptipText) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        { attrs: { "data-spm-item": "__default?typ=entry" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "chat-entrance",
                              attrs: { href: "javascript:void(0)" },
                            },
                            [
                              _c("chat-entrance-icon", {
                                attrs: {
                                  icon: _vm.chatEntranceConfig.icon,
                                  text: _vm.chatEntranceConfig.text,
                                },
                              }),
                              _vm._v(" "),
                              _vm.badgeNum
                                ? _c("div", { staticClass: "badge" }, [
                                    _vm.badgeNum > 99
                                      ? _c(
                                          "span",
                                          { staticClass: "plus-mark-box" },
                                          [_c("span", [_vm._v("99+")])]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(_vm.badgeNum)),
                                        ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                ]
              : _vm._e(),
          ]),
        ],
        2
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-63678164";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as ChatEntrance };
